import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ApiService } from './api.service';
import { ApiUrl } from './constants';
import { RequestParams } from '@src/app/shared/types/common';

@Injectable({
  providedIn: 'root',
})
export class CalculatorsService {
  private isLoadingSubject = new BehaviorSubject<boolean>(false);
  isLoading$: Observable<boolean> = this.isLoadingSubject.asObservable();

  constructor(private apiService: ApiService) {}

  setIsLoading(value: boolean): void {
    this.isLoadingSubject.next(value);
  }

  handleError(error: HttpErrorResponse): void {
    this.isLoadingSubject.next(false);

    if (error.error?.message) {
      console.error(error.error?.message);
    }
  }

  getLoansCalculators(
    params: RequestParams,
  ): Observable<Record<string, any>[]> {
    this.isLoadingSubject.next(true);

    return this.apiService.request({
      method: 'get',
      endpoint: ApiUrl.getLoansCalculators,
      params,
    });
  }

  getDepositsCalculators(
    params: RequestParams,
  ): Observable<Record<string, any>[]> {
    this.isLoadingSubject.next(true);

    return this.apiService.request({
      method: 'get',
      endpoint: ApiUrl.getDepositsCalculators,
      params,
    });
  }

  getDepositCalculatorRates(
    id: number,
    params: RequestParams,
  ): Observable<Record<string, any>> {
    this.isLoadingSubject.next(true);

    return this.apiService.request({
      method: 'get',
      endpoint: ApiUrl.getDepositCalculatorRates(id),
      params,
    });
  }
}
